import { Select, MenuItem, FormControl, InputLabel } from '@mui/material';

type Props = {
  value: boolean;
  onChange?: (value: boolean) => void;
  margin?: 'none' | 'dense' | 'normal' | undefined;
  label?: string;
};

const VisibleSelect = (props: Props) => {
  return (
    <FormControl fullWidth margin={props.margin}>
      <InputLabel>{props.label}</InputLabel>
      <Select
        size="small"
        label={props.label}
        value={props.value ? 'visible' : 'hidden'}
        onChange={(e) => {
          return props.onChange?.(e.target.value === 'visible');
        }}
        displayEmpty
      >
        <MenuItem value="visible">Visible</MenuItem>
        <MenuItem value="hidden">Hidden</MenuItem>
      </Select>
    </FormControl>
  );
};

export default VisibleSelect;
